"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = require("react");

const useCurrentState = initialState => {
  const [state, setState] = (0, _react.useState)(() => {
    return typeof initialState === 'function' ? initialState() : initialState;
  });
  const ref = (0, _react.useRef)(initialState);
  (0, _react.useEffect)(() => {
    ref.current = state;
  }, [state]);

  const setValue = val => {
    const result = typeof val === 'function' ? val(ref.current) : val;
    ref.current = result;
    setState(result);
  };

  return [state, setValue, ref];
};

var _default = useCurrentState;
exports.default = _default;
module.exports = exports.default;